import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Loading from './Loading';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Error display component
const ErrorDisplay = ({ error, onRetry }) => (
  <div className="error-container">
    <h2>Authentication Error</h2>
    <p>{error}</p>
    <button onClick={onRetry}>Try Again</button>
  </div>
);

function Callback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const accessToken = params.get('access_token');
      const error = params.get('error');
      const code = params.get('code');

      // Handle access token from backend
      if (accessToken) {
        localStorage.setItem('spotify_access_token', accessToken);
        navigate('/wrapped', { replace: true });
        return;
      }

      // Handle errors
      if (error) {
        navigate('/', { state: { error } });
        return;
      }

      // Handle Spotify authorization code
      if (!code) {
        navigate('/');
        return;
      }

      // Redirect to backend to handle OAuth exchange
      window.location.href = `${API_URL}/callback?code=${code}`;
    };

    handleCallback();
  }, [navigate, location]);

  return <Loading message="Connecting to Spotify..." />;
}

export default Callback; 